<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <i class="bi bi-chevron-left" onclick="window.location.href = '/auth'"></i>
                    </div>
                    <div class="col text-center">
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <br>
            <div class="container-fluid" style=padding-top:56px;>
                <div class="row justify-content-center">
                    <div class="col-11">
                        <div style="font-size:30px;color:#6C7072;">
                            パスワードを再設定
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <div class="row justify-content-center">
                    <div class="col-11">
                        <p class="error-text" id="error-box" v-if="is_login_error">
                            <i class="bi bi-x-circle-fill"></i>登録されていないメールアドレスです。
                        </p>
                        <div>
                            <span style="font-size:12px;color:#6B4EFF;"> メールアドレス </span>
                        </div>
                        <input type="email" class="luna-form-control" id="mail" name="mail" placeholder=""
                            v-model="email" />
                        <div class="" style="padding:15px 0; font-size:12px;color:#6C7072;">
                            ご登録いただいたメールアドレスを入力してください。<br>
                            register@luna_matching.comからパスワード変更ページのURLが記載されたメールを送信します。
                        </div>
                        <br />
                        <div class="d-grid gap-2" style="padding: 0 5px;">
                            <button type="button" class="btn btn-luna disabled" style="font-size:18px; padding:12px 0;"
                                v-if="is_load">
                                <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status" v-if="is_load">
                                    <span class="visually-hidden">Loading...</span>
                                </div>再設定メールを送信
                            </button>
                            <button type="button" class="btn btn-luna-d disabled" style="font-size:18px; padding:12px 0;"
                                v-else-if="isInValidEmail">再設定メールを送信</button>
                            <button type="button" class="btn btn-luna" style="font-size:18px; padding:12px 0;"
                                @click="setPass()" v-else>再設定メールを送信</button>
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: "",
            is_login_error: false,
            is_load: false,
        };
    },
    methods: {
        async setPass() {
            this.is_load = true

            await axios.post("/api/auth/pass/reset", {
                email: this.email,
            })
                .then((response) => {
                    if (response.data.res == '546') {
                        this.is_login_error = true
                    }
                    else {
                        window.location.href = "/auth/password/send/" + this.email
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('メールの送信に失敗しました。');
                    }
                }).finally(() => {
                    this.is_load = false
                })
        },
    },
    computed: {
        isInValidEmail() {
            //メールアドレスとして判定される文字列と記号の組み合わせを定数化
            const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
            //指定した組み合わせになっていなかった場合判定を返す。
            return !reg.test(this.email);
        }
    }
}
</script>
<style scoped>
.link {
    color: #212529
}

.link:hover {
    color: #212529
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    padding-top: 20px;
    height: 60px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}
</style>
